import { FC, memo } from 'react'
import Overview from './components/Overview'
import WalletList from './components/WalletList'
import styles from './index.module.scss'

const Wallet: FC = () => {
  return (
    <div className={styles.container}>
      <Overview />
      <WalletList />
    </div>
  )
}

export default memo(Wallet)
